import * as ReturnCodesConstants from '../../constants/ReturnCodesConstants'
import { Message } from 'element-ui'

export const checkReturnInfo = (result, func) => {
  // 根据返回状态给页面提示信息，然后刷新页面
  if (result.code === ReturnCodesConstants.SUCCESS_CODE) {
    Message.success(`${func}成功！`)
    return true
  } else {
    Message.error(`${func}失败！`)
    return false
  }
}

export const checkReturnStatus = (result) => {
  if (!result) {
    return false
  }
  // 根据返回状态判断成功还是失败
  if (result.code === ReturnCodesConstants.SUCCESS_CODE) {
    return true
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/common/utils/return-message-util.js